import { render, staticRenderFns } from "./CashInvoice.vue?vue&type=template&id=524da34b&scoped=true"
import script from "./CashInvoice.vue?vue&type=script&lang=js"
export * from "./CashInvoice.vue?vue&type=script&lang=js"
import style0 from "./CashInvoice.vue?vue&type=style&index=0&id=524da34b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524da34b",
  null
  
)

export default component.exports